import type { PropsWithChildren } from "react";
import { Navigate, useLocation } from "react-router-dom";
import LoadingState from "../common/LoadingState";
import { useCustomerAuth } from "../../context/CustomerAuthContext";

export default function RequireCustomer({ children }: PropsWithChildren) {
  const location = useLocation();
  const { customer, token, isBootstrapping } = useCustomerAuth();

  if (isBootstrapping) {
    return (
      <div className="aan-ticket-flow min-h-screen bg-black pt-36 text-white">
        <div className="section-frame">
          <LoadingState label="Checking your session..." />
        </div>
      </div>
    );
  }

  if (!customer || !token) {
    const redirect = encodeURIComponent(`${location.pathname}${location.search}`);
    return <Navigate to={`/login?redirect=${redirect}`} replace />;
  }

  return children;
}
